'use client';

import Icon from './Icon';
import svg from 'sprites/pause.svg';

export default function IconPause({
  className = 'w-15 h-15 fill-none stroke-brown'
}: {
  className?: string;
}) {
  return <Icon id={svg.id} className={className} />;
}
